export default __webpack_public_path__ + "static/media/wave-top.14e60c01.svg";